import React from "react";
import { 
  createTournament, 
  deleteTournament, 
  getListTournaments, 
  updateTournament 
} from "../../api";
import { Tournament } from "../../types";
import { BasePanel } from "./BasePanel";

export const TournamentsPanel: React.FC = () => {
  return (
    <BasePanel<Tournament>
      config={{
        title: "Tornei",
        elementName: "Torneo",
        getItems: () => getListTournaments({}),
        createItem: (data) => createTournament(data),
        updateItem: (id, data) => updateTournament(id, data),
        deleteItem: (id) => deleteTournament(id),
        renderItem: (item) => (
          <span className="text-sm sm:text-base font-medium mb-2 sm:mb-0">
            {item.name}
          </span>
        ),
        getTextField: (item) => item.name,
        fields: [
          { name: "name", label: "Nome torneo", type: "text", required: true },
        ],
      }}
    />
  )
}
